import script from "./DocumentViewer.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentViewer.vue?vue&type=script&setup=true&lang=js"

import "./DocumentViewer.vue?vue&type=style&index=0&id=0e0363a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e0363a8"]])

export default __exports__